export default __webpack_public_path__ + "static/media/ThePiano_07.036cd2ac.png";